/**
 * Comparing an id from the API with one that came through the DOM.
 *
 * <p>Ids are `bigint unsigned` on the server and arrive as JSON numbers. Anything that
 * has been through a `<select>`, an `<input>` or a route parameter is a string, because
 * that is all the DOM has. `42 === "42"` is false, so a comparison that mixes the two
 * silently finds nothing — which is how it fails: no error, just an empty result where a
 * row was expected.
 *
 * <p>While ids were UUID strings both sides happened to be strings and this could not
 * arise. It can now, so it is named rather than left to be rediscovered.
 */
export const sameId = (a, b) =>
  a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b);
